
class PrintWidgetApi{
	constructor(canonicalUrl = document.querySelector('[rel="canonical"]').getAttribute('href')){
		this._url = canonicalUrl;

	}
	get url(){
		if(this._url==null || this._url==""){
			this._url = document.location.pathname;
		}
		return this._url;
	}
	get printUrl(){
		
		let printUrl = `${this.url.split("_")[0]}_print`;
		return printUrl;
	}

	print(){
	    let printWindow = window.open(this.printUrl, 'articleprintwin', 'scrollbars=1,resizable=1,width=760,height=440');
	    printWindow.focus();
	    window.socialCp("print");
	}
}

export {PrintWidgetApi}